module.exports = __webpack_public_path__ + "media/homepage/builder-hero-f848f86b.svg";